import { useId } from "react";
import { motion } from "framer-motion";

export const LogoSymbol = ({ animated = false, className = "", strokeWidth = 6 }) => {
  const rawId = useId().replace(/[^a-zA-Z0-9]/g, "");
  const gid = `spg-${rawId}`;
  const Path = animated ? motion.path : "path";
  const Circle = animated ? motion.circle : "circle";

  return (
    <svg viewBox="0 0 120 56" fill="none" className={className} aria-hidden="true">
      <defs>
        <linearGradient id={gid} x1="0" y1="56" x2="120" y2="0" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#2563EB" />
          <stop offset="0.5" stopColor="#38BDF8" />
          <stop offset="1" stopColor="#FF8A00" />
        </linearGradient>
      </defs>
      <Circle
        cx="12" cy="44" r="7" fill={`url(#${gid})`}
        {...(animated ? { initial: { scale: 0, opacity: 0 }, animate: { scale: 1, opacity: 1 }, transition: { duration: 0.4, ease: "backOut" } } : {})}
        style={animated ? { transformOrigin: "12px 44px" } : undefined}
      />
      <Path
        d="M 12 44 C 40 46, 58 24, 94 15"
        stroke={`url(#${gid})`} strokeWidth={strokeWidth} strokeLinecap="round" fill="none"
        {...(animated ? { initial: { pathLength: 0 }, animate: { pathLength: 1 }, transition: { duration: 1.1, delay: 0.35, ease: [0.65, 0, 0.2, 1] } } : {})}
      />
      <Path
        d="M 94 15 L 74 13 M 94 15 L 92 35"
        stroke={`url(#${gid})`} strokeWidth={strokeWidth} strokeLinecap="round" fill="none"
        {...(animated ? { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.35, delay: 1.35 } } : {})}
      />
    </svg>
  );
};

export const Logo = ({ compact = false, dark = false }) => (
  <div className="flex items-center gap-3" data-testid="brand-logo">
    <LogoSymbol className={compact ? "w-10 h-5" : "w-12 h-6"} />
    <div className="leading-none">
      <span className={`block font-display font-black tracking-tight ${compact ? "text-base" : "text-lg"} ${dark ? "text-white" : "text-navy"}`}>
        STARTING POINT
      </span>
      <span className={`block font-display font-semibold tracking-[0.42em] ${compact ? "text-[8px]" : "text-[10px]"} ${dark ? "text-white/60" : "text-navy/50"}`}>
        AGENCY
      </span>
    </div>
  </div>
);
